import { useEffect, useState } from "react";

export type Theme = "light" | "dark";

const STORAGE_KEY = "berrymail-theme";

// El selector de tema está oculto en la UI por ahora (sigue existiendo acá
// y en tokens.css para cuando se reactive) — mientras tanto, claro siempre
// por defecto, sin mirar preferencia de sistema ni un valor viejo guardado
// en localStorage de cuando el selector sí estaba visible.
function getInitialTheme(): Theme {
  return "light";
}

export function useTheme(): [Theme, (theme: Theme) => void] {
  const [theme, setThemeState] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  function setTheme(next: Theme) {
    localStorage.setItem(STORAGE_KEY, next);
    setThemeState(next);
  }

  return [theme, setTheme];
}
